/**
 * Точка входа. Порядок важен: стили подключаются до первого рендера, личные
 * настройки (тема и плотность) выставляются на <html> до монтирования —
 * иначе тёмная тема мигнёт светлой на первом кадре.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './styles/index.css'
import { App } from './app/App.js'
import { applyStoredPrefs } from './app/prefs.js'
/* Движение подключается последним: один набор переходов на всё приложение,
   он нарочно перекрывает частные правила компонентов. */
import './styles/motion.css'

applyStoredPrefs()

const container = document.getElementById('root')
if (!container) throw new Error('Не найден контейнер #root')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
